export class SgfProducto {
    codProducto: number;
    nomProducto: string;
    codTipoProducto: number;
    stsProducto: string;
    txtFormato: string;
    codGrupo: number;

}
